import React, { createContext, useContext, useState, useEffect } from "react";
import { Box, LinearProgress, Link, Typography } from "@mui/material";
import LocalUnionCard from "../../../components/LocalUnionCard";
import MemberService from "../../../services/MemberService";
import axios from "axios";

import "./Memberships.css";

export const MembershipContext = createContext();

// Hook for child components to get the membership data
export const useMembership = () => {
    return useContext(MembershipContext);
};

function Memberships({ memberships = [], hasPendingNMEs = true, isLoading = false, hideTitle = false, paddingBottom = false }) {
    const [organizationName, setOrganizationName] = useState('Membership Organization');
    const [organizationShortName, setOrganizationShortName] = useState('');
    const [directoryWebsite, setDirectoryWebsite] = useState('https://example.org/directory');
    
    useEffect(() => {
        const source = axios.CancelToken.source();
        
        MemberService.getOrganizationName(source.token)
            .then(data => {
                if (data) {
                    setOrganizationName(data);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching organization name:', error);
                }
            });
            
        MemberService.getOrganizationShortName(source.token)
            .then(data => {
                if (data) {
                    setOrganizationShortName(data);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching organization short name:', error);
                }
            });
            
        MemberService.getDirectoryWebsite(source.token)
            .then(data => {
                if (data) {
                    setDirectoryWebsite(data);
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.error('Error fetching directory website:', error);
                }
            });
            
        return () => {
            source.cancel();
        };
    }, []);
    return (
        <Box className="local-list" sx={paddingBottom ? { padding: "24px 32px 40px 32px" } : {}}>
            {!hideTitle && (
                <>
                    <Typography variant="h5">
                        {memberships?.length > 1 ? "Memberships" : "Membership"}
                    </Typography>
                    {/* Only show contact message if user has memberships or no pending NMEs */}
                    {(memberships?.length > 0 || !hasPendingNMEs) && (
                        <Typography variant="body2" color="GrayText">
                            Need membership assistance? Please contact your local union using the details below.
                        </Typography>
                    )}
                </>
            )}
            {isLoading ? (
                <Box sx={{ height: "20px" }}>
                    <LinearProgress />
                </Box>
            ) : memberships?.length > 0 ? (
                <Box className="local-list-scroller" sx={{ marginTop: "10px" }}>
                    {memberships.map((membership) => (
                        <MembershipContext.Provider key={membership.membership?.id ?? membership.id} value={membership}>
                            <LocalUnionCard />
                        </MembershipContext.Provider>
                    ))}
                </Box>
            ) : hasPendingNMEs ? (
                <Typography variant="body2" color="GrayText">
                    You are not an active member in the system yet.
                </Typography>
            ) : (
                <>
                    <Typography variant="body2" color="GrayText" fontWeight="bold" gutterBottom>
                        You have no active memberships or enrollment applications pending.
                    </Typography>
                    <Typography variant="body2" color="GrayText">
                        Please use the <Link href="/portal/fasttrack">{organizationShortName} FastTrack Membership Enrollment Form</Link> to apply for membership to your local union or go to the <Link href={directoryWebsite}>{organizationName} website</Link> to contact your local union representative.
                    </Typography>
                </>
            )}
        </Box>
    );
}

export default Memberships;